jQuery(function () {
  var selector = '[data-behaviour~="show-admin-search-spotlight"]';
  var spotlight = "#admin-search-spotlight";

  var modal = new Modal({
    header: "Search",
    body: jQuery(spotlight),
    class: "admin-modal admin-modal--search-spotlight",
  });

  // BEHAVIOUR

  jQuery(document).on("click", selector, clickHandler);

  // EVENTS HANDLERS

  function clickHandler(e) {
    e.preventDefault();

    modal.show();
    jQuery(".query_input", spotlight).focus();
  }
});
